/**
 * Rappel de ce qui est affiché, tel que le serveur l'a compris (`meta`) :
 * période, fuseau, périmètre réel (un non-admin sur « all » est rabattu sur sa
 * branche), et date d'évaluation des stocks.
 */
import React from 'react';
import { Space, Tag, Typography } from 'antd';
import { useTranslation } from 'react-i18next';
import type { Meta } from '../../../api/monitoring/v2';
import { INK } from '../monitoringTheme';
import { useFormat } from './format';

const { Text } = Typography;

const MetaBanner: React.FC<{ meta: Meta }> = ({ meta }) => {
    const { t } = useTranslation();
    const f = useFormat();
    return (
        <Space size={8} wrap data-testid="meta-banner">
            <Text style={{ fontSize: 12, color: INK.secondary }}>
                {t('monitoring.periodLabel', { from: f.date(meta.period.from), to: f.date(meta.period.to), tz: meta.period.tz })}
            </Text>
            {meta.scope.name && <Text style={{ fontSize: 12, color: INK.secondary }}>· {meta.scope.name}</Text>}
            <Tag bordered={false}>{t(`monitoring.periodKind.${meta.period.kind}`)}</Tag>
        </Space>
    );
};

export default MetaBanner;
